<template>
	<div v-if="defaultGridView && gridViewField">
		<template>
			<component
				v-if="isComponent"
				:tabIndex="tabIndex"
				:gridViewField="gridViewField"
				:defaultGridView="defaultGridView"
				:item="item"
				:record="record"
				:is="isComponent"
				:isBulkEdit="isBulkEdit"
				@valueChanged="onValueChanged"
			/>
		</template>
	</div>
</template>
<script>
const AmountField = () =>
	import('@/components/shared/fields/grids/AmountField.vue');
const ApprovalStatusField = () =>
	import('@/components/shared/fields/grids/ApprovalStatusField.vue');
const BooleanField = () =>
	import('@/components/shared/fields/grids/BooleanField.vue');
const DatetimeField = () =>
	import('@/components/shared/fields/grids/DatetimeField.vue');
const DateField = () =>
	import('@/components/shared/fields/grids/DateField.vue');
const FileField = () =>
	import('@/components/shared/fields/grids/FileField.vue');
const LongTextField = () =>
	import('@/components/shared/fields/grids/LongTextField.vue');
const NumberField = () =>
	import('@/components/shared/fields/grids/NumberField.vue');
const NumberDoubleField = () =>
	import('@/components/shared/fields/grids/NumberDoubleField.vue');
const TextField = () =>
	import('@/components/shared/fields/grids/FieldText.vue');
const UserField = () =>
	import('@/components/shared/fields/grids/UserField.vue');
const ReferenceListField = () =>
	import('@//components/shared/fields/grids/ReferenceListField.vue');
const LinkField = () =>
	import('@//components/shared/fields/grids/LinkField.vue');
const UnknownField = () =>
	import('@/components/shared/fields/grids/UnknownField.vue');
const AutoGeneratedField = () =>
	import('@/components/shared/fields/grids/AutoGeneratedField.vue');

import { FieldDataTypes } from '../../../enums/fieldDataTypes';
import { GridsPageEditActions } from '../../../store/actions';
import { GridsPageEditGetters } from '../../../store/getters';
import { mapGetters } from 'vuex';
export default {
	name: 'GridField',
	props: {
		gridViewField: Object,
		defaultGridView: Object,
		tabIndex: Number,
		isBulkEdit: Boolean,
	},
	components: {
		AutoGeneratedField,
		AmountField,
		ApprovalStatusField,
		BooleanField,
		DatetimeField,
		DateField,
		FileField,
		LongTextField,
		NumberField,
		NumberDoubleField,
		TextField,
		UserField,
		UnknownField,
		ReferenceListField,
		LinkField,
	},
	computed: {
		...mapGetters({
			item: [GridsPageEditGetters.ITEM],
			record: [GridsPageEditGetters.RECORD],
		}),

		isComponent() {
			if (this.gridViewField.LinkFieldId) return LinkField;
			if (this.gridViewField.ReferenceListTypeId)
				return ReferenceListField;
			switch (this.gridViewField.DataField.DataType) {
				case FieldDataTypes.TEXT:
					return TextField;
				case FieldDataTypes.LONG_TEXT:
					return LongTextField;
				case FieldDataTypes.NUMBER:
					return NumberField;
				case FieldDataTypes.DOUBLE:
					return NumberDoubleField;
				case FieldDataTypes.AMOUNT:
					return AmountField;
				case FieldDataTypes.BOOLEAN:
					return BooleanField;
				case FieldDataTypes.DATETIME:
					return DatetimeField;
				case FieldDataTypes.DATE:
					return DateField;
				case FieldDataTypes.APPROVAL_STATUS:
					return ApprovalStatusField;
				case FieldDataTypes.FILE:
					return FileField;
				case FieldDataTypes.USER:
					return UserField;
				case FieldDataTypes.AUTOGENERATED_NUMBER:
				case FieldDataTypes.AUTOGENERATED_UNIQUEIDENTIFIER:
				case FieldDataTypes.AUTOGENERATED_DATETIME:
				case FieldDataTypes.AUTOGENERATED_BOOLEAN:
					return AutoGeneratedField;
			}

			return UnknownField;
		},
	},

	methods: {
		onValueChanged(itemKeys, recordKeys, isNull) {
			if (itemKeys)
				itemKeys.forEach((ik) => {
					if (isNull) {
						this.$store.dispatch(
							GridsPageEditActions.UPDATE_ITEM_KEY,
							{
								itemKey: ik.key,
								value: ik.value,
							}
						);
					} else {
						if (ik.value == null) {
							this.$store.dispatch(
								GridsPageEditActions.REMOVE_ITEM_KEY,
								ik.key
							);
						} else if (
							!(ik.value instanceof File) &&
							ik.value.toString().trim().length == 0
						) {
							this.$store.dispatch(
								GridsPageEditActions.REMOVE_ITEM_KEY,
								ik.key
							);
						} else {
							this.$store.dispatch(
								GridsPageEditActions.UPDATE_ITEM_KEY,
								{
									itemKey: ik.key,
									value: ik.value,
								}
							);
						}
					}
				});
			if (recordKeys)
				recordKeys.forEach((rk) => {
					if (isNull) {
						this.$store.dispatch(
							GridsPageEditActions.UPDATE_RECORD_KEY,
							{
								recordKey: rk.key,
								value: rk.value,
							}
						);
					} else {
						if (rk.value == null) {
							this.$store.dispatch(
								GridsPageEditActions.REMOVE_RECORD_KEY,
								rk.key
							);
						} else if (
							!(rk.value instanceof File) &&
							rk.value.toString().trim().length == 0
						) {
							this.$store.dispatch(
								GridsPageEditActions.REMOVE_RECORD_KEY,
								rk.key
							);
						} else {
							this.$store.dispatch(
								GridsPageEditActions.UPDATE_RECORD_KEY,
								{
									recordKey: rk.key,
									value: rk.value,
								}
							);
						}
					}
				});
		},
	},
	destroyed() {
		this.$store.dispatch(GridsPageEditActions.CLEAR);
	},
};
</script>
<style lang="scss">
.gvf-md {
	.gvf {
		max-height: auto;
	}
}
</style>
